const initialState={
    type:'all',
    titletxt:'all',
    searchText:'',
}

export default initialState;